module.exports = __webpack_public_path__ + "media/img/covers/sidebar-cover-67800023c9069518ebacc46bf7a518d9.jpg";